'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 1860
// module chunks = 1